import React from 'react';
import { AlertCircleIcon } from './Icon';
import './InlineNotice.scss';

export default function InlineNotice({ children }) {
  return <div className="wiw-inline-notice" role="status" aria-atomic="true">
    <AlertCircleIcon />
    <span>{children}</span>
  </div>;
}
